<div class="check-impossible-dialog-wrapper">
    <h1 mat-dialog-title>Warum war die Prüfung nicht möglich?</h1>
    <form (ngSubmit)="saveReason()">
    <mat-dialog-content>
            <div class="warn-box">
                <mat-icon class="warn-icon">warning</mat-icon>
                <span class="warn-msg"><b>Unterlagen sind neu einzureichen.</b><br>Dieser Schritt kann nicht rückgängig gemacht werden.</span>
            </div>
            <mat-form-field class="check-impossible-dialog-comment">
                <mat-label>Kommentar</mat-label>
                <input matInput placeholder="Bitte Begründung eintragen" [(ngModel)]="commentText" name="commentText">
            </mat-form-field>

    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton="outlined"
            type="submit"
            [disabled]="!commentText.trim()"
            >
        Speichern
        </button>
        <button matButton="outlined" type="button" (click)="closeDialog()">
        Abbrechen
        </button>
    </mat-dialog-actions>
    </form>
</div>
